module.exports = __webpack_public_path__ + "img/icon-file-w.bf798b69.svg";